module.exports = __webpack_public_path__ + "static/media/20ECE29.c282c6df.jpg";